/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('store.form-allowed-categories', function (el) {
        var allowedCategoriesElement = el.querySelector('#elm_allowedCategoryIds');
        if (!allowedCategoriesElement) {
            return;
        }
        var lmnt = allowedCategoriesElement.querySelector('.category-list');
        if (!lmnt) {
            return;
        }
        var rows = lmnt.querySelectorAll('.category-row');
        if (!rows.length) {
            return;
        }
        setDataAttributes(rows);
        createCategoryGroups(rows, lmnt);
        createCategoryGroupTools(lmnt);
        delegateSelectAll(allowedCategoriesElement);
        delegateSelectNone(allowedCategoriesElement);
        delegateCategoryChange(allowedCategoriesElement);
    });
    function isRootCategory(el) {
        return el.dataset.isRoot === 'true';
    }
    function setDataAttributes(rows) {
        rows.forEach(function (row) {
            var mainLabel = row.querySelector('.label-main');
            if (mainLabel) {
                var textContent = mainLabel.textContent.trim();
                var isRoot = !textContent.startsWith('-');
                if (isRoot) {
                    row.dataset.isRoot = 'true';
                }
            }
        });
    }
    function createCategoryGroups(rows, destinationElement) {
        var categoryGroups = [];
        var currCategoryGroup = [];
        var rowsArray = Array.from(rows);
        rowsArray.forEach(function (row, i) {
            currCategoryGroup.push(row);
            var nextRow = (i < rowsArray.length - 1) ? rowsArray[i + 1] : null;
            if (!nextRow || isRootCategory(nextRow)) {
                categoryGroups.push(currCategoryGroup);
                currCategoryGroup = [];
            }
        });
        rowsArray.forEach(function (row) {
            row.remove();
        });
        categoryGroups.forEach(function (groupRows) {
            var groupElement = document.createElement('div');
            groupElement.classList.add('category-group');
            var toolsElement = document.createElement('div');
            toolsElement.classList.add('tools');
            groupElement.append(toolsElement);
            destinationElement.appendChild(groupElement);
            var wrap = document.createElement('div');
            wrap.classList.add('wrap');
            groupRows.forEach(function (row) {
                wrap.appendChild(row);
            });
            groupElement.appendChild(wrap);
        });
    }
    function createCategoryGroupTools(container) {
        var groups = container.querySelectorAll('.category-group');
        groups.forEach(function (group) {
            var toolsElement = group.querySelector('.tools');
            if (!toolsElement)
                return;
            var selectAll = document.createElement('button');
            selectAll.classList.add('tool');
            selectAll.classList.add('selectAll');
            selectAll.title = 'Velja flokk og alla undirflokka';
            toolsElement.appendChild(selectAll);
            var selectNone = document.createElement('button');
            selectNone.classList.add('tool');
            selectNone.classList.add('selectNone');
            selectNone.title = 'Af-velja flokk og alla undirflokka';
            toolsElement.appendChild(selectNone);
        });
    }
    function delegateSelectAll(context) {
        util.delegate(context, 'click', '.selectAll', function (e) {
            e.preventDefault();
            var group = e.delegateTarget.closest('.category-group');
            var inputs = group.querySelectorAll('.js-allowed-cb');
            inputs.forEach(function (input) {
                if (!input.checked) {
                    input.checked = true;
                    // This event dispatch ensures the listener below runs
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });
    }
    function delegateSelectNone(context) {
        util.delegate(context, 'click', '.selectNone', function (e) {
            e.preventDefault();
            var group = e.delegateTarget.closest('.category-group');
            var inputs = group.querySelectorAll('input[type=checkbox]');
            inputs.forEach(function (input) {
                if (input.checked) {
                    input.checked = false;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });
    }
    function delegateCategoryChange(context) {
        util.delegate(context, 'change', '.js-allowed-cb', function (e) {
            var allowedCheckbox = e.delegateTarget;
            var row = allowedCheckbox.closest('.category-row');
            var quickSelectCheckbox = row.querySelector('.js-quick-cb');
            if (quickSelectCheckbox) {
                if (allowedCheckbox.checked) {
                    quickSelectCheckbox.disabled = false;
                }
                else {
                    quickSelectCheckbox.checked = false;
                    quickSelectCheckbox.disabled = true;
                }
            }
        });
    }

}());
typeof tsBuild === 'function' && tsBuild();})();
